import Big, { BigSource } from 'big.js';
import { add, isNumber } from 'lodash';

export const formatQuoteNumber = (value: number) => {
  const displayStr = new Intl.NumberFormat('en-US', {
    notation: 'standard',
    maximumSignificantDigits: 20,
  }).format(value);

  return displayStr;
};

export const formatQuoteValue = (value: number) => {
  const displayStr = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumSignificantDigits: 3,
  }).format(value);

  return displayStr;
};

export const formatPercentage = (pctValue: BigSource) => {
  const pct = Big(pctValue);
  if (pct.abs().lt(1000)) {
    return `${pct.toFixed(2)}%`;
  }
  return `${pct.div(100).toFixed(2)}x`;
};

export const formatQuoteValueStandard = (value: Big | number) => {
  const displayStr = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'standard',
  }).format(isNumber(value) ? value : value.toNumber());

  return displayStr;
};

export const formatAddress = (
  address: string,
  prefix = 6,
  suffix = 6,
  symbol = '......',
) => {
  if (address.length <= prefix + suffix) return address;
  return (
    address.substring(0, prefix) +
    symbol +
    address.substring(address.length - suffix)
  );
};

export const CryptoFormats = {
  ETH: {
    decimal: 18,
    format: 6,
  },
  USDC: {
    decimal: 6,
    format: 6,
  },
};

export function eToNumber(num: number | '') {
  if (num === '' || Number.isNaN(num)) return '';
  try {
    return Big(num).toFixed();
  } catch {}
  return '';
}

export const formatValue = (value: number | string, format = 8) => {
  if (value === '') return '0';
  let str = eToNumber(+value); //防止出现e
  if (str.includes('.')) {
    let [prefix, suffix] = str.split('.');
    if (suffix.length > format) {
      suffix = suffix.substring(0, format);
    }
    return eToNumber(Number.parseFloat(`${prefix}.${suffix}`));
  } else return str;
};

export const formatNumber = (value: number | undefined) => {
  if (value === undefined) return '';
  return new Intl.NumberFormat('en-US').format(value);
};

export function addThousandSeparator(number: number | string) {
  // 先将数字转为字符串，并判断是否有小数部分
  let [integerPart, decimalPart] = number.toString().split('.');

  // 对整数部分添加千分位分隔符
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // 如果有小数部分，则拼接整数部分和小数部分
  if (decimalPart) {
    return integerPart + '.' + decimalPart;
  } else {
    return integerPart;
  }
}

export const formatNumberValue = (value: number | '', format?: number) => {
  if (value === '') return '';
  if (value < 1e-2) {
    return eToNumber(value);
  }
  if (value > 1e5) value = Math.floor(value);
  return addThousandSeparator(formatValue(value, format));
};

export function truncateString(str: string, num = 10) {
  if (str.length > num) {
    return str.slice(0, num) + '...';
  }
  return str;
}

export const isSameAddress = (
  a: string | undefined,
  b: string | undefined,
) => {
  if (a === undefined || b === undefined) return false;
  return a.toLowerCase() === b.toLowerCase();
};

export function shortenAddress(
  address: string,
  start = 6,
  end = 4,
): string {
  return `${address?.slice(0, start)}...${address?.slice(-end)}`;
}

export const formatNumberValueV2 = (
  number: number | string,
  decimal = 8,
) => {};
//小数点后，0后面的8位  toPrecision
export const formatNumberWihtNoQuote = (
  value: number | '',
  format = 8,
) => {
  if (value === '') return '';
  if (value < 1) {
    return eToNumber(+value.toPrecision(format));
  } else if (value > 1e5) {
    value = Math.floor(value);
    return eToNumber(value);
  }
  return formatValue(value, format);
};

export const formatNumberV2 = (
  value: number | '' | undefined,
  format = 8,
) => {
  if (value === '' || value === undefined) return '';
  let _value = eToNumber(value);
};

export const getPastTime = (time: number) => {
  const diff = Date.now() - time;
  if (diff < 1000 * 60) {
    return Math.floor(diff / 1000).toString() + 'Sec';
  } else if (diff < 1000 * 60 * 60) {
    return Math.floor(diff / 1000 / 60).toString() + 'Min';
  } else if (diff < 1000 * 60 * 60 * 24) {
    return Math.floor(diff / 1000 / 60 / 60).toString() + 'Hour';
  } else if (diff < 1000 * 60 * 60 * 24 * 30) {
    return Math.floor(diff / 1000 / 60 / 60 / 24).toString() + 'Day';
  } else if (diff < 1000 * 60 * 60 * 24 * 365) {
    return Math.floor(diff / 1000 / 60 / 60 / 24 / 30).toString() + 'Mon';
  } else
    return (
      Math.floor(diff / 1000 / 60 / 60 / 24 / 365).toString() + 'Year'
    );
};
